export default __webpack_public_path__ + "static/21-7619e242914940a81bcf969deaaf9bad.png";